export const addPersonsAction = (personData) => ({
  type: 'ADD_PERSONS',
  personData,
});

export const addPlacesAction = (placesData) => ({
  type: 'ADD_PLACES',
  placesData,
});

export const addWorldEventsAction = (worldEvents) => ({
  type: 'ADD_WORLD_EVENTS',
  worldEvents,
});
